import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from "react";
import PropTypes from "prop-types";
import { getRehydratableName, getClassNameFactory } from "../../../../utilities";
import classNames from "classnames";
import contextTypes from "../../contextTypes";

var Panel = /*#__PURE__*/function (_Component) {
  _inherits(Panel, _Component);

  var _super = _createSuper(Panel);

  function Panel() {
    _classCallCheck(this, Panel);

    return _super.apply(this, arguments);
  }

  _createClass(Panel, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          id = _this$props.id,
          tabTitle = _this$props.tabTitle,
          render = _this$props.render;
      var getClassName = getClassNameFactory("TabsPanel");
      var isOpen = this.context.currentOpenPanel === id;
      return /*#__PURE__*/React.createElement("section", {
        "aria-labelledby": "tab-".concat(id),
        role: "tabpanel",
        className: getClassName({
          states: classNames({
            hidden: !isOpen
          })
        }),
        "data-rehydratable": getRehydratableName(Panel.displayName),
        "data-tab-title": tabTitle,
        id: id,
        hidden: !isOpen,
        tabIndex: "-1"
      }, /*#__PURE__*/React.createElement("div", {
        "data-rehydratable-children": true
      }, render && render(isOpen), children));
    }
  }]);

  return Panel;
}(Component);

_defineProperty(Panel, "displayName", "Tabs.Panel");

_defineProperty(Panel, "propTypes", {
  /**
   * The contents of this panel.
   */
  render: PropTypes.any,

  /**
   * The contents of this panel.
   */
  children: PropTypes.node,

  /**
   * The id of this panel. Should be unique on the current page.
   */
  id: PropTypes.string.isRequired,

  /**
   * The title of this panel, which will be shown in its associated tab.
   */
  tabTitle: PropTypes.string.isRequired,

  /**
   * The title to display in data-label attribute.
   */
  dataAttribute: PropTypes.string
});

_defineProperty(Panel, "contextTypes", contextTypes);

export default Panel;